/**
 * Container Styles
 * 
 * Responsive layout styles for the global Container component.
 * Defines consistent spacing, max-widths, and padding across device sizes.
 * 
 * Interactions:
 * - Uses TypeScript interface for border prop typing
 * - Implements mobile-first responsive breakpoints
 * - Provides consistent content width constraints across the application
 * - Supports optional top border for content section separation
 * - Handles overflow and positioning for proper content containment
 */

import styled from "styled-components";

export const StyledContainer = styled("div")<{
  border?: boolean;
}>`
  position: relative;
  width: 100%;
  max-width: 1300px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 60px;
  overflow: hidden;
  border-top: ${(p) => (p.border ? "1px solid #CDD1D4" : "")};

  @media only screen and (max-width: 1024px) {
    max-width: calc(100% - 68px);
    padding: 0 30px;
  }

  @media only screen and (max-width: 768px) {
    max-width: calc(100% - 38px);
    padding: 0 18px;
  }

  @media only screen and (max-width: 414px) {
    max-width: 100%;
    padding: 0 18px;
  }
`;
